import { CONFIG, EnvType } from "../../config/config";
import version from "../../version.json";
import { ApiService, FetchInterceptor } from "./api-service";

export type ApiVersionNumber = 1 | 2;

export enum Scope {
  Admin = "https://cs.myota.cloud/admin",
}

export abstract class DataService {
  protected readonly api: ApiService;

  addFetchInterceptor(fetchInterceptor: FetchInterceptor): void {
    this.api.addFetchInterceptor(fetchInterceptor);
  }

  removeFetchInterceptor(fetchInterceptor: FetchInterceptor): void {
    this.api.removeFetchInterceptor(fetchInterceptor);
  }

  protected encodeUri(uri?: string): string | null {
    if (!uri) {
      return null;
    }
    return window.btoa(uri);
  }

  constructor(urlPrefix?: string, apiVersion: ApiVersionNumber = 2) {
    const apiUrl =
      CONFIG.type && CONFIG.type === EnvType.ProductionK8
        ? `${window.location.protocol}//${window.location.host}/api/v${apiVersion}`
        : `${CONFIG.apiURL}/v${apiVersion}`;

    this.api = new ApiService(apiUrl, urlPrefix, {
      myota_agent: `os: aws; version: ${version?.version}`,
    });
  }
}
